export const BASE_URL_API = "https://api.coinnikmarket.xyz/";
export const COIN_GECKO_BASE_RUL = "https://api.coingecko.com/api/";
export const PANEL_COINNIK_BASE_RUL = "https://panel.coinnik.com/api/";
